import React, { useContext, useState } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context'
import Table from '../../../components/Table'
import Button from '../../../components/Button'
import Confirmation from '../../../components/Confirmation/Confirmation'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import Modal from './extraModal/PublicLoadModal'
import { createEducationRecord, updateEducationRecord, deleteEducationRecord } from '../../../actions/students/other'


export default function PublicLoad() {

  const dispatch = useDispatch()
  const { studentTabData, studentId } = useContext(StudentsContext)

  const { public_load: publicLoadData } = studentTabData || {}

  const [selectedRow, setSelectedRow] = useState(null)
  const [modalData, setModalData] = useState(null)
  const [modalAddMode, setModalAddMode] = useState(false)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  const items = Array.isArray(publicLoadData) ? publicLoadData : []

  const handleAdd = () => {
    setModalAddMode(true)
    setModalData({})
  }

  const handleEdit = () => {
    if (selectedRow !== null && items[selectedRow]) {
      setModalAddMode(false)
      setModalData(items[selectedRow])
    }
  }

  const handleDeleteClick = () => {
    if (selectedRow !== null && items[selectedRow]) {
      setShowDeleteConfirm(true)
    }
  }

  const handleDeleteConfirm = () => {
    const item = items[selectedRow]
    if (item?.xp_pf_pl) {
      dispatch(deleteEducationRecord(studentId, 'public_load', item.xp_pf_pl))
    }
    setSelectedRow(null)
    setShowDeleteConfirm(false)
  }

  const handleSaveItem = (itemData) => {
    if (modalAddMode || !itemData.xp_pf_pl) {
      dispatch(createEducationRecord(studentId, 'public_load', itemData))
    } else {
      dispatch(updateEducationRecord(studentId, 'public_load', itemData.xp_pf_pl, itemData))
    }
    setModalData(null)
    setSelectedRow(null)
  }

  const closeModal = () => setModalData(null)

  return (
    <div className={styles.tabWrapper}>
      {modalData !== null && (
        <Modal
          closeModal={closeModal}
          data={modalData}
          height={'430px'}
          addMode={modalAddMode}
          onSave={handleSaveItem}
        />
      )}

      {showDeleteConfirm && (
        <Confirmation
          title='Вы уверены, что хотите удалить запись?'
          acceptConfirmation={handleDeleteConfirm}
          rejectConfirmation={() => setShowDeleteConfirm(false)}
        />
      )}

      <div className={styles.qualificationForm}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Общественная нагрузка</th>
              <th>С</th>
              <th>По</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => (
              <tr
                key={item.xp_pf_pl || idx}
                onClick={() => setSelectedRow(idx)}
                style={{ cursor: 'pointer', backgroundColor: selectedRow === idx ? '#DEECFF' : 'transparent' }}
              >
                <td>{item.public_load || ''}</td>
                <td>{item.begdate ? moment(item.begdate).format('DD.MM.YYYY') : ''}</td>
                <td>{item.enddate ? moment(item.enddate).format('DD.MM.YYYY') : ''}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className={styles.inputsRow} style={{ marginTop: '0.5rem' }}>
          <Button mode='bordered' onClick={handleAdd}>Добавить</Button>
          <Button mode='bordered' onClick={handleEdit} disabled={selectedRow === null}>Изменить</Button>
          <Button mode='bordered' onClick={handleDeleteClick} disabled={selectedRow === null}>Удалить</Button>
        </div>
      </div>
    </div>
  )
}
